module.exports = __webpack_public_path__ + "img/ic_food_manage_bottom_item_img1.aa194202.png";